"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var client_1 = require("react-dom/client");
require("./index.scss");
var App_1 = __importDefault(require("./src/App"));
var axios_1 = __importDefault(require("axios"));
var utils_1 = require("utils");
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var careersApplications = document.getElementById("careers-portal-form");
var GET_FORM_OPTIONS = "/form_options";
var UPLOAD_FILE = "/applications/upload-file/";
var CREATE_APPLICATION = "/applications/create";
var GET_TOKEN = "/generate_token";
var GET_JOBS = "/jobs";
var LOGGER = "/careers/api/v1/logger/create";
function getPrefix() {
    return "/" + window.drupalSettings.path.pathPrefix;
}
exports.client = axios_1.default.create({
    baseURL: getPrefix() + "careers/api/v1",
    headers: {
        "Content-Type": "application/json",
        "Accept-Language": (0, utils_1.getLangcode)(),
    },
});
exports.client.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    void axios_1.default.post(LOGGER, {
        message: error.message,
    });
    (0, utils_1.handleError)(error);
    return Promise.reject(error);
});
if (careersApplications) {
    (0, client_1.createRoot)(careersApplications).render((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(App_1.default, { back: window.history.back, push: function (path) {
                    window.location.pathname = path;
                }, query: new URLSearchParams(window.location.search), showTitle: false, showJobSelect: true, tittle: "", urls: {
                    GET_FORM_OPTIONS: GET_FORM_OPTIONS,
                    UPLOAD_FILE: UPLOAD_FILE,
                    CREATE_APPLICATION: CREATE_APPLICATION,
                    GET_TOKEN: GET_TOKEN,
                    GET_JOBS: GET_JOBS,
                } }), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, {})] }));
}
